module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h1",
    attrs: {
      "id": "ch00_fm04_title"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _vm._v("The Heart "), _c('span', {
    staticClass: "underline"
  }, [_vm._v("of")]), _vm._v(" Leadership")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Becoming a Leader People"), _c('br'), _vm._v("Want to Follow")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('strong', [_vm._v("Mark Miller")])]), _vm._v(" "), _c('p', {
    staticClass: "publisher"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pub.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eec25808","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm04_title.vue
// module id = 66
// module chunks = 0